<!--
 * @Author: guoyu
 * @Date: 2021-04-21 11:59:29
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-05 16:59:23
 * @Description: 新人红包
-->
<template>
  <div class="over-lay" v-show="dialogVisible && newerCoupon">
    <div class="newer-coupon">
      <div class="coupon-top">{{$t('components_login_components_newer_redbag_1073')}}</div>
      <div class="coupon-amount">
        <span class="amount">{{ newerCoupon.couponAmount }}</span>
        <span class="unit">{{$t('upgrade_page_views_home_suggest_item_4')}}</span>
      </div>
      <div class="footer-button">
        <NormalButton class="use-coupon" @click="useCoupon"
          >{{$t('upgrade_page_views_order_components_coupons_bar_336')}}</NormalButton
        >
      </div>
      <p class="coupon-text">{{$t('components_login_components_newer_redbag_1074')}}</p>
      <p class="coupon-text">{{$t('components_login_components_newer_redbag_1075')}}
        {{ new Date(newerCoupon.deadlineTimestamp).$format('yyyy-MM-dd') }}
      </p>
      <div class="close-dialog el-icon-circle-close" @click="closeDialog"></div>
    </div>
  </div>
</template>
<script>
import NormalButton from '@/components/common/button/normal';
import { mapGetters } from 'vuex'
export default {
  components: {
    NormalButton
  },
  data() {
    return {
      dialogVisible: true,
    };
  },
  computed: {
    ...mapGetters(['newerCoupon']),
  },
  methods: {
    useCoupon() {
      this.dialogVisible = false;
      this.$emit('useCoupon');
      this.$router.replace({
        path: '/coupons'
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$router.replace({
        path: '/'
      });
      this.$emit('close');
    }
  }
};
</script>
<style lang="scss" scoped>
.over-lay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
}
.newer-coupon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 517px;
  height: 534px;
  color: #FEC09B;
  background: url(./images/newer-coupon-bg.png) no-repeat;
  background-size: 100% 100%;
}
.coupon-top {
  width: 281px;
  margin: 99px auto 0;
  text-align: center;
  font-size: 24px;
  line-height: 34px;
  color: #feeab7;
}
.coupon-amount {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 200px;
  margin: 48px auto 0;
  font-weight: 600;
  font-weight: 700;
  font-size: 120px;
  line-height: 1;
  color: #fa004fcc;
  text-shadow: 1px 3px 6px #fff, 0 0 0 #000, 1px 3px 6px #fff;
}
.unit {
  margin-top: 12px;
  font-size: 36px;
}
.footer-button {
  margin-top: 36px;
  text-align: center;
}
.use-coupon {
  width: 158px;
  height: 40px;
  margin: 24px auto 24px;
  /deep/ .button-box {
    color: #9b5a12;
  }
}
.coupon-text {
  margin-bottom: 6px;
  font-size: 12px;
  text-align: center;
  line-height: 1;
}
.close-dialog {
  position: absolute;
  bottom: -33px;
  transform: translateY(100%);
  width: 100%;
  text-align: center;
  font-size: 29px;
  color: #ffffff;
}
</style>
